import script from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"

import "./CallToAction.vue?vue&type=style&index=0&id=5d1d8645&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1d8645"]])

export default __exports__